/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 后端响应session管理
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-19 14:45:24
 * @LastEditTime: 2023-04-10 14:21:55
 * @FilePath: /client-h5-v2/src/store/modules/session.ts
 */

export const session = {
  namespaced: true, // 防止模块命名冲突 设置后调用mutations和action需要'模块名/方法' 例如  app/setMenuList
  state: {
    serviceId: '',
    turnId: '',
    userId: '',
    sessionIdMF: ''
  },
  getters: {
    serviceId: (state: any) => state.serviceId,
    turnId: (state: any) => state.turnId,
    userId: (state: any) => state.userId,
    sessionIdMF: (state: any) => state.sessionIdMF
  },
  mutations: {
    SET_SERVICE_ID (state: { serviceId: string }, serviceId: string) {
      state.serviceId = serviceId
    },
    SET_TURN_ID (state: {turnId: string}, turnId: string) {
      state.turnId = turnId
    },
    SET_USER_ID (state: {userId: string}, userId: string) {
      state.userId = userId
    },
    SET_SESSION_ID_MF (state: {sessionIdMF: string}, sessionIdMF: string) {
      state.sessionIdMF = sessionIdMF
    }
  },
  actions: {
    /**
     * @description: 异步获取配置文件、根据配置文件处理url参数
     * @param {any} store
     * @param {any} data
     */
    sessionFn (store: any, data:any):void {
      store.commit('SET_SERVICE_ID', data.serviceId)
      store.commit('SET_TURN_ID', data.turnId)
      store.commit('SET_USER_ID', data.userId)
    }
  }
}

